
import stilogo from "./sti-logo.png"
import socalgaslogo from "./SoCalGas_logo.webp"
import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table'
import { useLocation } from 'react-router-dom'
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


import { ViewSubscriberHistoryModal } from "./ViewSubscriberHistoryModal";
import { getLocale, setLocale } from "./i18nRefs.jsx";
import { dict } from "./i18n";

import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import { alertshistory } from "./api";


import awsExports from './aws-exports';
Amplify.configure(awsExports);



export default function AlertsHistory() {

  const location = useLocation();
  let [historyData, setHistoryData] = useState([]);
  let [rowclicked, setRowClicked] = useState(false);
  let [subhistoryData, setSubscriberHistoryData] = useState([]);
  let [notificationdate, setNotificationDate] = useState("");
  let [subscriberType, setSusbscriberType] = useState("");
  let [showsubscribers, setShowSubscribers] = useState(location && location.state ? location.state.showSubscribers : false);
  const [locale, setLocalLocale] = useState(getLocale())
  const [i18n, seti18n] = useState(dict[getLocale()])
  const [loaded, setLoaded] = useState(false)
  let navigate = useNavigate();

  const prettytimestamp = (time_at) => {
    const dateObject = new Date(time_at * 1000)
    return dateObject.toLocaleString().replace(',', '') //2019-12-9, 10:30:15
  }

  const renderSubscribersView = (index, isSMS) => {
    isSMS ? setSubscriberHistoryData(historyData[index].alertsmssubscribers) : setSubscriberHistoryData(historyData[index].alertemailsubscribers)
    isSMS ? setNotificationDate(historyData[index].pretty_created_at) : setNotificationDate(historyData[index].pretty_created_at)
    isSMS ? setSusbscriberType("SMS") : setSusbscriberType("Email")
    setRowClicked(true);
  }

  const gotoadminscreen = () => {
    let path = `../admin`;
    navigate(path);
  }

  useEffect(() => {
    let mounted = true;
    try {
      alertshistory()
        .then(items => {
          if (mounted) {
            // console.log(items)
            setHistoryData(items.sort((a, b) => a.created_at < b.created_at ? 1 : -1))
            setLoaded(true)
          }
        })
    } catch (e) {
      console.error("oh noes", e)
    }
    return () => { mounted = false; }
  }, [])

  return (
    <main>
      {!loaded && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
      />
      }

      {loaded &&
        <div className="App">
          <div>
            {locale === "en_us"
              ? <button style={{ float: 'right' }} className={"btn btn-link locale-link"} onClick={() => setLocale('es')}>Español</button>
              : <button style={{ float: 'right' }} className={"btn btn-link locale-link"} onClick={() => setLocale('en_us')}>English</button>
            }
          </div>
          <button style={{ float: 'left' }} className={"btn btn-link locale-link"} onClick={gotoadminscreen}>{i18n.ADMIN}</button>
          {<div style={{ margin: 'auto', height: '300px', textAlign: 'center', display: 'block' }} >
            <br />
            <h4>{i18n.ALERTS_HISTORY}</h4>
            <br />
            <Table responsive striped bordered hover size="sm" style={{ display: 'block', height: '300px', overflow: 'auto' }}>
              <thead>
                <tr>
                  {showsubscribers && <React.Fragment>
                    <th>{i18n.EMAIL_SUBSCRIBERS}</th>
                    <th>{i18n.SMS_SUBSCRIBERS}</th>
                  </React.Fragment>}
                  <th>{i18n.Notification_Time}</th>
                  <th>{i18n.EMAIL_CONTENT}</th>
                  <th>{i18n.SMS_CONTENT}</th>
                </tr>

              </thead>

              <tbody>
                {historyData.map((val, key) => {
                  return (
                    <tr key={key}>
                      {showsubscribers && <React.Fragment>
                        <td>
                          <button type="button" className="btn btn-link"
                            onClick={() => renderSubscribersView(key, false)}
                          >{i18n.VIEW}</button> </td>
                        <td>
                          <button type="button" className="btn btn-link"
                            onClick={() => renderSubscribersView(key, true)}
                          >{i18n.VIEW}</button> </td>
                      </React.Fragment>}
                      <td>{prettytimestamp(val.created_at)}</td>
                      <td>{val.alertcustomtext}</td>
                      <td>{val.alertcustomsms}</td>
                    </tr>
                  )
                })}
              </tbody>

            </Table>
          </div>
          }

          <div className={"text-center"} style={{ marginTop: '20px', marginBottom: '20px' }}>
            <br />
            <br />
            <br />
            {i18n.OPERATED_BY}<br />
            <img src={stilogo} alt={"Sonoma Technology, Inc."} style={{ height: '32px' }} />
          </div>
          <div id={"featured-3"} className={"px-4 py-5"} style={{ backgroundColor: "lightgray" }}>
            <div className="col-lg-6 mx-auto">
              <p dangerouslySetInnerHTML={{ __html: i18n.SOCALGAS_OPPORTUNITY_TEXT }}>
              </p>
              <p style={{ fontSize: "small", marginTop: "40px" }}>
                {i18n.SOCALGAS_AUTHORIZED_CONTRACTOR}
              </p>
              <p style={{ fontSize: "small" }}>
                {i18n.REFERENCES_HEREBY}
              </p>
              <p dangerouslySetInnerHTML={{ __html: i18n.SOCALGAS_TERMSCONDITION_POLICY }} style={{ fontSize: "small" }}>
              </p>
              <p style={{ fontSize: "small" }}>
                {i18n.TRADEMARK_STATEMENT}
              </p>
              <div className={"text-center"}>
                <img src={stilogo} alt={"Sonoma Technology, Inc."} style={{ height: '64px' }} />
              </div>

              <div className={"text-center"} style={{ marginTop: '20px' }}>
                <img src={socalgaslogo} alt={"SoCalGas"} style={{ height: '64px' }} />
              </div>

            </div>

          </div>
          <ViewSubscriberHistoryModal showModal={rowclicked} subscriberType={subscriberType} notificationdate={notificationdate} subhistoryData={subhistoryData} onClose={() => setRowClicked(false)} />

        </div>
      }

    </main >
  );
}

